var map = {
	"./audioCall.svg": "a4c2",
	"./clip.svg": "9d0f",
	"./cursor.svg": "22a7",
	"./cursor_pointer.svg": "aff6",
	"./device.svg": "f66f",
	"./emoji.svg": "9325",
	"./lesson3_dialog1.svg": "4599",
	"./location.svg": "d2eb",
	"./message.svg": "612e",
	"./notifications.svg": "f587",
	"./photo.svg": "7e86",
	"./picker.svg": "a5f4",
	"./placeholder.svg": "0139",
	"./plus.svg": "eb38",
	"./popup_img_1.svg": "6591",
	"./popup_img_2.svg": "813a",
	"./portrait_dummy.svg": "506f",
	"./speed.svg": "6c2d",
	"./success.svg": "1c27",
	"./task-ok.svg": "4721",
	"./videoCall.svg": "3b10",
	"./videoChat.svg": "b646",
	"./voice_message.svg": "88c3",
	"./warning.svg": "daa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";